/**
 * What a person signed in to a cluster console may do, read off the role the
 * server recomputes on every request.
 *
 * Role and not capabilities, and that is the contract's decision rather than a
 * shortcut here: a cluster console has one thing to administer and one role
 * that administers it. The account's list of capabilities no longer carries
 * `manage_catalog` at all — nobody there does — so a console that gated this
 * screen on capabilities would be gating it on a list that is always empty of
 * the only entry it cared about.
 *
 * Hiding is all this does. The server refuses regardless: every write below is
 * checked again there, against the group this tenancy's Cedar policy names, as
 * it stands at that moment.
 */

import type { ClusterSession } from '../api/types';

/** A member of the group this tenancy's policy names as its administrators. */
export function mayManageCatalogue(session: ClusterSession | null): boolean {
  return session !== null && session.role === 'cluster_admin';
}
